import Highcharts from 'highcharts';
const categories = ["Agricultura", "Todos los<br />productos"];

export const figure34 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
            fontFamily: 'Montserrat'
        },
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    plotOptions: {
        // series: {
        //     borderWidth: 0
        // }
    },
    exporting: {
        enabled: false
    },
    xAxis: {
        tickWidth: 0,
            categories: [
                {
                    name: "Regiones en desarrollo",
                    categories: categories
                },
                {
                    name: "Países en desarrollo<br />sin litoral (PDL)",
                    categories: categories
                },
                {
                    name: "Países menos adelantados (PMA)",
                    categories: categories
                },
                {
                    name: "Pequeños Estados insulares<br />en desarrollo (PEID)",
                    categories: categories
                }
            ],
            title: {
                text: null,
                style: {
                    color: Highcharts.getOptions().colors[1]
                }
            },
            // labels: {
            //     reserveSpace: true,
            //     groupedOptions: [
            //         {
            //             rotation: 0,
            //             style: {transform: 'unset', 'transform-origin': '74% 12px', 'padding-right': '16px'},
            //         }
            //         ],
            //     rotation: -90,
            //     useHTML: true,
            //     style: {
            //         transform: 'rotate(-90deg)',
            //         'transform-origin': '50% 11px',
            //         width: 'unset',
            //         'padding-right': '42px',
            //         overflow: 'visible'
            //     },
            // },
    },
    yAxis: {
            title: {
                text: null
            },
            gridLineWidth: 2,
            floor: 0,
            ceiling: 80,
            tickInterval: 10,
            lineColor: "#d7d7d7",
            tickColor: "#d7d7d7",
            tickLength: 16,
            labels: {
                style: {
                    fontWeight: 'normal',
                    color: '#999999',
                    fontSize: '12px'
                },
            },
    },
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        valueSuffix: '%',
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    series: [
    {
            name: '2015',
            color: '#5b9bd5',
            data: [ 
                50.682,
                49.309,
                72.51,
                72.798,
                69.009,
                63.833,
                60.417,
                59.424
             ]
    },
    {
        name: '2019',
        color: '#ed7c31',
        data: [
            53.907,
            52.16,
            74.159,
            74.03,
            75.065,
            66.295,
            69.224,
            67.165
         ]
    }
    ]
}
